import clsx from 'clsx';
import React from 'react';

interface chipVariantsType {
  primary: string;
  primaryLight: string;
  secondary: string;
  error: string;
  green: string;
  golden: string;
  gray: string;
}

interface sizesType {
  sm: string;
}

function Chip({
  children,
  extraClasses = '',
  size = 'sm',
  variant = 'primary',
}: {
  children: React.ReactNode;
  variant?: string;
  size?: string;
  extraClasses?: string;
}) {
  const variants: chipVariantsType = {
    primary: 'text-primary-dark bg-primary-dark/10',
    primaryLight: 'text-primary-light bg-primary-lighter',
    secondary: 'text-secondary-dark bg-secondary-dark/10',
    error: 'text-error bg-error/10',
    green: 'text-green-500 bg-green-100',
    golden: 'text-[#b99561] bg-[#f8e6c9]',
    gray: 'text-gray-500 bg-gray-200',
  };

  // Button different sizes
  const sizes: sizesType = {
    sm: 'p-2 text-xs',
  };

  // Combine classes
  const className = clsx(
    {
      'flex justify-center text-center rounded-full font-medium focus:outline-none focus-visible:outline-none':
        true,
    },
    variants[variant as keyof chipVariantsType],
    sizes[size as keyof sizesType],
    extraClasses
  );

  return <div className={className}>{children}</div>;
}

export default Chip;
